module.exports = __webpack_public_path__ + "img/parachute.e03911e5.svg";